module.exports = __webpack_public_path__ + "img/tutorial.d851424f.svg";